import { PaymentContainerComponent } from './containers/payment-container/payment-container.component';
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

const routes:  Routes =[
  {path: 'payment', component: PaymentContainerComponent}
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PaymentRoutingModule {}
